(() => {
  'use strict';

  // Purchase notice bar + dialog (rendered by snippets/product-purchase-notice.liquid).
  // Listens for the `variant:change` event dispatched from the theme's selectCallback
  // to keep the availability text in sync with the selected variant.

  const BODY_OPEN_CLASS = 'product-purchase-notice-is-open';
  const VISIBLE_CLASS = 'is-visible';
  const CLOSE_TRANSITION_MS = 240;

  const escapeHtml = (value) => String(value)
    .replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  const setAvailability = (notice, variant) => {
    if (!variant) return;

    const textContainer = notice.querySelector('.product-purchase-notice__text');
    if (!textContainer) return;

    const availabilityText = variant.available ? escapeHtml(notice.dataset.inStockText || '') : 'Nicht verfügbar';
    let availability = notice.querySelector('[data-purchase-notice-availability]');

    if (!availabilityText) {
      // No text to show -> remove the wrapper entirely (keeps separators from dangling)
      if (availability) availability.remove();
    } else {
      if (!availability) {
        availability = document.createElement('span');
        availability.className = 'product-purchase-notice__availability';
        availability.setAttribute('data-purchase-notice-availability', '');
        textContainer.prepend(availability);
      }

      availability.textContent = availabilityText;
    }

    notice.dataset.availabilityStatus = variant.available ? 'in-stock' : 'out-of-stock';
    notice.dataset.variantId = variant.id;
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-purchase-notice]').forEach((notice) => {
      if (notice.dataset.purchaseNoticeReady === 'true') return;
      notice.dataset.purchaseNoticeReady = 'true';

      const dialogId = notice.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;

      let closeTimer = null;

      const openDialog = () => {
        if (dialog.open) return;
        document.body.classList.add(BODY_OPEN_CLASS);
        notice.setAttribute('aria-expanded', 'true');
        dialog.showModal();
        requestAnimationFrame(() => {
          dialog.classList.add(VISIBLE_CLASS);
        });
      };

      const closeDialog = () => {
        if (!dialog.open) return;
        notice.setAttribute('aria-expanded', 'false');
        dialog.classList.remove(VISIBLE_CLASS);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          dialog.close();
          document.body.classList.remove(BODY_OPEN_CLASS);
        }, CLOSE_TRANSITION_MS);
      };

      notice.addEventListener('click', openDialog);
      dialog.addEventListener('click', (event) => {
        // Clicks on the dialog itself (= backdrop) close; panel clicks have inner targets
        if (event.target === dialog) closeDialog();
      });
      dialog.querySelectorAll('[data-purchase-notice-close]').forEach((button) => {
        button.addEventListener('click', closeDialog);
      });
      dialog.addEventListener('cancel', (event) => {
        // ESC should play the close animation instead of closing instantly
        event.preventDefault();
        closeDialog();
      });
      dialog.addEventListener('close', () => {
        dialog.classList.remove(VISIBLE_CLASS);
        document.body.classList.remove(BODY_OPEN_CLASS);
        notice.setAttribute('aria-expanded', 'false');
      });
    });
  };

  document.addEventListener('variant:change', (event) => {
    document.querySelectorAll('[data-product-purchase-notice]').forEach((notice) => {
      setAvailability(notice, event.detail ? event.detail.variant : null);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
